export default "__VITE_ASSET__98f821cf__"